
<template>
  <div v-if="data" v-wechat-title="title">
    <div class="groupRectBase">
      <div class="title" :style="'background-color: '+data.team.baseColor+';color:'+data.team.fontColor">确认信息
        <div class="topButton"><i class="iconfont iconback" @click="onBack" /></div>
      </div>
      <div class="about">
        <div class="imgRect">
          <img :src="commodityIcon">
        </div>
        <div v-if="data.team.isNeedSelectCertificate && !selectCertification" class="selectRectEmpty" :style="'border: 2px solid '+data.team.baseColor" @click="onSelectCertification">
          请选择潜水资质
        </div>
        <div v-if="data.team.isNeedSelectCertificate && selectCertification" class="selectRect" :style="'border: 2px solid '+data.team.baseColor" @click="onSelectCertification">
          {{ selectCertification.cerificateName }} ({{ selectCertification.groupTeam }})
        </div>

        <div v-if="!address" class="selectRectEmpty" :style="'border: 2px solid '+data.team.baseColor" @click="onAddressChange(false)">
          请选择收件地址
        </div>
        <div v-if="address" class="selectRect" :style="'border: 2px solid '+data.team.baseColor" @click="onAddressChange(true)">
          {{ address.zipString }}{{ address.address }}
        </div>
      </div>
    </div>

    <div class="groupDownButton">
      <van-button type="default" size="large" :color="data.team.baseColor" @click="onGoNext">确认信息无误,下一步</van-button>
    </div>

    <van-popup v-model="showPicker" position="bottom">
      <van-picker
        :loading="loadingCertifications"
        show-toolbar
        :columns="certifications.list"
        value-key="cerificateName"
        @cancel="showPicker = false"
        @confirm="onConfirmCertification"
      />
    </van-popup>

  </div>
</template>
<script>
import request from '@/utils/request'
import { Button, Popup, Picker } from 'vant'
import { MyNotify, getUrlKey } from '@/utils/base'
import commondata from '@/commondata.js'
import Cookies from 'js-cookie'
export default {
  components: {
    [Button.name]: Button,
    [Popup.name]: Popup,
    [Picker.name]: Picker
  },
  data() {
    return {
      title: '团购活动',
      backurl: '/store/index',
      key: undefined,
      data: undefined,
      commodityId: undefined,
      selectCommodity: undefined,
      certifications: [],
      loadingCertifications: true,
      selectCertification: undefined,
      showPicker: false,
      selectAdressId: undefined,
      address: undefined,
      nickName: undefined,
      commodityIcon: undefined
    }
  },
  activated() {
    this.commodityId = getUrlKey('commodity')
    this.nickName = Cookies.set('GroupNickName_')
    this.key = this.$route.params.key
    this.init()

    if (commondata.selectAddress) {
      this.selectAdressId = commondata.selectAddress.id
    } else {
      this.selectAdressId = undefined
    }
    this.onInitAddress()
  },
  created() {
    // this.commodityId = getUrlKey('commodity')
    // this.key = this.$route.params.key
    // this.init()
  },
  methods: {
    init() {
      request({
        url: '/StoreHelper/getGroupBuy',
        method: 'get',
        params: { key: this.key }
      }).then(response => {
        if (!response.success) {
          return
        }
        this.data = response.data
        this.title = this.data.team.shortName
        this.data.commodity.forEach(item => {
          if (item.groupBuyCommodityId === this.commodityId) {
            this.selectCommodity = item
          }
        })
        if (this.data.commodity.length === 1) {
          this.selectCommodity = this.data.commodity[0]
        }
        this.commodityIcon = this.selectCommodity.icon
        this.commodityId = this.selectCommodity.groupBuyCommodityId
        this.updateDiyUrl()
      })
    },
    updateDiyUrl() {
      if (!this.selectCommodity.diyIcon) {
        return
      }
      const url = this.selectCommodity.diyIcon +
        '?specificationId=' + this.selectCommodity.specificationId +
        '&nickName=' + encodeURIComponent(this.nickName) +
        '&certificateTeam=' + encodeURIComponent(this.selectCertification ? this.selectCertification.groupTeam : '') +
        '&certificateId=' + encodeURIComponent(this.selectCertification ? this.selectCertification.cerificateId : '')
      if (url !== this.commodityIcon) {
        this.commodityIcon = url
      }
    },
    onSelectCertification() {
      this.loadingCertifications = true
      this.showPicker = true
      this.getUserVerificate(() => {
        this.loadingCertifications = false
      })
    },
    onConfirmCertification(value) {
      console.log('onConfirmCertification', value)
      this.selectCertification = value
      this.showPicker = false
      this.updateDiyUrl()
    },
    getUserVerificate(callback) {
      request({
        url: '/user/getUserCertificate',
        method: 'post'
      }).then(response => {
        if (!response.success) {
          return
        }
        this.certifications = response.data
        if (callback) {
          callback()
        }
      })
    },
    onBack() {
      window.history.length > 1
        ? this.$router.go(-1)
        : this.$router.push('/group/groupCommodity/' + this.key)
    },
    onAddressChange(isHave) {
      if (isHave) {
        this.$router.push('/store/addressList')
      } else {
        this.$router.push('/store/addressEdit')
      }
    },
    onInitAddress() {
      request({
        url: '/StoreHelper/getUserAddress',
        method: 'post',
        params: { addressId: this.selectAdressId }
      }).then(response => {
        if (!response.success) {
          return
        }
        if (response.data) {
          this.address = response.data
          this.selectAdressId = this.address.addressId
        } else {
          this.address = undefined
          this.selectAdressId = undefined
        }
      })
    },
    onGoNext() {
      if (!this.selectAdressId) {
        MyNotify('info', '请选择收件地址')
        return
      }
      if (this.data.team.isNeedSelectCertificate) {
        if (!this.selectCertification) {
          MyNotify('info', '请选择潜水资质')
          return
        }
      }
      var url = '/group/grouPayType/' + this.key +
       '?commodity=' + this.commodityId +
        '&address=' + this.selectAdressId
      if (this.data.team.isNeedSelectCertificate) {
        url += '&certificate=' + this.selectCertification.cerificateId +
         '&team=' + this.selectCertification.groupTeam
      }
      this.$router.push(url)
    }
  }
}
</script>
<style scoped>

.groupRectBase .imgRect{
  text-align: center;
}
.groupRectBase img{
    width: 80%;
}

.selectRect{
  margin: 1em 0;
  border-radius: 0.2em;
  padding: 1em;
}

.selectRectEmpty{
  margin: 1em 0;
  border-radius: 0.2em;
  padding: 1em;
  background-color: #eee;
  color: #999;
  text-align: center;
}
</style>
